enum LogoColors {
	Alternative = 'rgb(39, 51, 66)',
	Primary = 'rgb(15, 88, 214)',
	Secondary = 'rgb(255, 255, 255)',
}

export default LogoColors;
